import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "className", "hairline", "dashed", "contentPosition"];
import React, { useContext } from 'react';
import cls from 'clsx';
import ConfigProviderContext from '../config-provider/ConfigProviderContext';

var Divider = function Divider(_ref) {
  var children = _ref.children,
      className = _ref.className,
      hairline = _ref.hairline,
      dashed = _ref.dashed,
      contentPosition = _ref.contentPosition,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useContext = useContext(ConfigProviderContext),
      prefixCls = _useContext.prefixCls,
      createNamespace = _useContext.createNamespace;

  var _createNamespace = createNamespace('divider', prefixCls),
      _createNamespace2 = _slicedToArray(_createNamespace, 1),
      bem = _createNamespace2[0];

  return /*#__PURE__*/React.createElement("div", _extends({
    role: "separator",
    className: cls(className, bem(_defineProperty({
      dashed: dashed,
      hairline: hairline
    }, "content-".concat(contentPosition), !!children)))
  }, props), children);
};

Divider.defaultProps = {
  hairline: true,
  contentPosition: 'center'
};
export default Divider;